<template>
  <div id="center">
    <div class="up">
      <el-tag class="tileSize">付费模块销量</el-tag>
      <dv-scroll-ranking-board class="mt-1 scrollBoardUp" ref="scrollBoardUp" style="height: 160px" :config="itemConfig"  />
    </div>
    <div class="down">
      <el-tag class="mt-1 tileSize">业务地区分布</el-tag>
      <dv-scroll-ranking-board class="mt-1 scrollBoardUp" ref="scrollBoardDown" style="height: 160px" :config="areaConfig"  />
    </div>
  </div>
</template>

<script>

import autoResize from "@jiaminghi/data-view/lib/mixin/autoResize";

export default {
  name: "companySell",
  mixins: [autoResize],
  data() {
    return {
      areaConfig: {
        data: [
          {
            name: "<div style='font-size: 16px;'>阜宁</div>",
            value: 55
          },
          {
            name: "<div style='font-size: 16px;'>上海</div>",
            value: 120
          },
          {
            name: "<div style='font-size: 16px;'>山东</div>",
            value: 78
          },
          {
            name: "<div style='font-size: 16px;'>驻马店</div>",
            value: 66
          },
          {
            name: "<div style='font-size: 16px;'>杭州</div>",
            value: 80
          },
          {
            name: "<div style='font-size: 16px;'>苏州</div>",
            value: 45
          },
        ],
        unit: '家'

      },
      itemConfig: {
        data: [
          {
            name: "<div style='font-size: 16px;'>WMS工作流程</div>",
            value: 55
          },
          {
            name: "<div style='font-size: 16px;'>PMS项目管理</div>",
            value: 120
          },
          {
            name: "<div style='font-size: 16px;'>PCS生产控制</div>",
            value: 78
          },
          {
            name: "<div style='font-size: 16px;'>CRM客户管理</div>",
            value: 66
          },
          {
            name: "<div style='font-size: 16px;'>CS云空间</div>",
            value: 80
          },
          {
            name: "<div style='font-size: 16px;'>人脸识别</div>",
            value: 80
          },
        ],
        unit: '个'
      },
    }
  },
  watch: {

  },
  components: {
  },
  methods: {
    updateRankingValueFontSize() {
      let rankingValueElements = document.querySelectorAll('.ranking-value');
      Array.from(rankingValueElements).forEach(element => {
        element.style.fontSize = '16px';
      });
    },
  },
  mounted() {
      // this.renderChart();
      this.observer = new MutationObserver(() => {
        this.updateRankingValueFontSize();
      });
      this.observer.observe(document.body, { childList: true, subtree: true });
  },
  beforeDestroy() {
    this.observer.disconnect();  // 清理观察者
  }
}
</script>

<style lang="scss" scoped>
#center {
  display: flex;
  flex-direction: column;
  width: 100%;
  .up {
    width: 95%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: space-around;

    .tileSize {
      color: rgb(0, 186, 255);
      font-size: 20px;
      text-align: center;
      width:100%;
      margin: 0 auto;
    }

    .item {
      border-radius: 6px;
      padding-top: 8px;
      margin-top: 8px;
      width: 32%;
      height: 70px;
      .dv-dig-flop {
        width: 100%;
        height: 30px;
      }

    }
  }
  .down {
    padding: 6px 4px;
    padding-bottom: 0;
    width: 95%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: space-around;

    .tileSize {
      color: rgb(0, 186, 255);
      font-size: 20px;
      text-align: center;
      width:100%;
      margin: 0 auto;
    }
    .scrollBoardUp {
      margin-top: 10px;
    }
    .bg-color-black {
      border-radius: 5px;
    }
    .ranking {
      padding: 10px;
      width: 59%;
      .dv-scr-rank-board {
        height: 225px;
      }
    }
    .percent {
      width: 40%;
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 50%;
        height: 120px;
        display: flex;
        flex-direction: column;
        align-items: center;
        span {
          margin-top: 8px;
          font-size: 14px;
          display: flex;
          justify-content: center;
        }
      }
      .water {
        width: 100%;
        .dv-wa-le-po {
          width: 100%;
          height: 120px;
          text-align: center;
        }
      }
    }
  }
}
</style>
